module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bQfud"))).then(() => parcelRequire('dJXJK'));